import { Popup } from "react-leaflet";
import { BOXGROUP_ID, ID_GROUPS } from "../../../../../Utils/const";

const BoxPopup = (props) => {

    return <>
        <Popup>
            <div className="title" >{props.box.name}</div>
            <div className="content">
                {props.box?.metrics?.map((m, i) => {
                    if (m.code !== 'VO' & m.code !== 'TE') {
                        return <div key={i} className="item">
                            <span className="item-title">{m.name}: </span>
                            {props.record && Object.keys(props.record).some(key => key === m.code) ?
                                (ID_GROUPS.SL === BOXGROUP_ID ? m.code.includes("DR") ? (props.record[m.code] / 1000).toFixed(2) + " m" : m.code === "RA" ? props.record[m.code] + " mm" : props.record[m.code] + " m" 

                                : props.record[m.code]) 
                                : "0"
                            }
                        </div>
                    }else return null
                })}
            </div>
        </Popup>
    </>
};

export default BoxPopup;
